module.exports = __webpack_public_path__ + "static/media/book.aee36ec4.png";